import React from "react";
import styled from "styled-components";

export default function TwitterDescription() {
  return (
    <ul>
      <ListItem>
        <b>Full responsiveness: </b> allowing both the interface and images to
        adjust perfectly to any screen size.
      </ListItem>
      <ListItem>
        <b>Interactive tooltips: </b> on essentials, pricing, questions
        sections.
      </ListItem>
      <ListItem>
        <b>Mobile/desktop navbar.</b>
      </ListItem>
      <ListItem>
        <b>Contextual hints that open to guide users.</b>
      </ListItem>
      <ListItem>
        <b>"Caruseal" with users comments on sm/desktop screen sizes.</b>
      </ListItem>
    </ul>
  );
}

const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 8px;
`;
